/**
 * 可注入的時鐘。存在的唯一理由是讓 max_age / stale 這類時間相關行為
 * 能被確定性地測試——kernel 不得有無法在 Node 裡完整測試的行為。
 */

export interface Clock {
  now(): number
}

export const systemClock: Clock = {
  now: () => Date.now(),
}

/** 測試用：手動推進的時鐘 */
export class ManualClock implements Clock {
  private current: number

  constructor(start = 0) {
    this.current = start
  }

  now(): number {
    return this.current
  }

  advance(ms: number): void {
    this.current += ms
  }

  set(ms: number): void {
    this.current = ms
  }
}
